import React, { createContext, useState } from "react";

export const LoadingContext = createContext({
  loadingCount: 0,
  isOpaque: false,
  /**
     * Although it is possible to remove the following I like to keep them here
     * because they help anyone importing LoadingContext to understand what API (methods)
     * this particular context has available
     */
  showLoading: () => {},
  hideLoading: () => {}
});

const LoadingProvider = (props) => {
  const { children } = props;
  /**
     * Loading state/controls
    */
  const showLoading = (isOpaque) => {
    toggleLoading((prevState) => {
      return {
        ...prevState,
        loadingCount: prevState.loadingCount + 1,
        isOpaque
      };
    });
  };

  const hideLoading = () => {
    toggleLoading((prevState) => {
      return {
        ...prevState,
        loadingCount: prevState.loadingCount > 0 ? prevState.loadingCount - 1 : 0
      };
    });
  };

  const loadingState = {
    loadingCount: 0,
    showLoading,
    hideLoading
  };

  const [loading, toggleLoading] = useState(loadingState);

  return (
    <LoadingContext.Provider value={loading}>
      {children}
    </LoadingContext.Provider>
  );
};

export default LoadingProvider;
